import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            追剧热评
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            追剧热评
          </h2>
          <p className="text-sm text-foreground-500 mt-2">来自真实剧迷的使用感受</p>
        </div>
        <div className="space-y-4">
          {commentItems.map((comment) => (
            <article
              key={comment.name}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 flex gap-4"
            >
              <img
                src={comment.avatar}
                alt={comment.name}
                className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                loading="lazy"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900">{comment.name}</h3>
                  <span className="text-xs text-foreground-500">{comment.date}</span>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-500">
                  <i className="ri-heart-fill text-accent-500" />
                  <span>{comment.likes.toLocaleString()}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}